import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { 
  BarChart3, 
  Lightbulb, 
  Trash, 
  Home, 
  Dumbbell,
  Footprints,
  Baby,
  Droplet,
  ParkingCircle,
  Droplets,
  Users,
  Zap
} from 'lucide-react';
import { LightPoleIcon, BenchIcon } from './icons/InventoryIcons';


const InventorySummaryCards = ({
  stats, 
  showInventoryDetail, 
  showFacilityDetail, 
  showIrrigationDetail,
  showRunningTrackDetail,
  showPlaygroundDetail,
  showSportsEquipmentDetail,
  showFountainDetail,
  onUnassignedParkClick // Yeni prop - atanmamış park tıklandığında
}) => {
  return (
    <>
      {/* Envanter Özeti */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <BarChart3 className="h-5 w-5 text-blue-600" />
            Envanter Özeti
          </CardTitle>
          <CardDescription>Tüm parklardaki envanter toplamları</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
            <div 
              onClick={() => showInventoryDetail("Elektrik Direği", "light_pole_count")}
              className="text-center p-4 bg-yellow-50 rounded-lg cursor-pointer hover:bg-yellow-100 transition-colors"
            >
              <LightPoleIcon className="h-8 w-8 text-yellow-600 mx-auto mb-2" />
              <p className="text-2xl font-bold text-yellow-900">{stats.totalLightPoles}</p>
              <p className="text-xs text-yellow-700">Elektrik Direği</p>
            </div>
            
            <div 
              onClick={() => showInventoryDetail("Bank", "bench_count")}
              className="text-center p-4 bg-orange-50 rounded-lg cursor-pointer hover:bg-orange-100 transition-colors"
            >
              <BenchIcon className="h-8 w-8 text-orange-600 mx-auto mb-2" />
              <p className="text-2xl font-bold text-orange-900">{stats.totalBenches}</p>
              <p className="text-xs text-orange-700">Bank</p>
            </div>
            
            <div 
              onClick={() => showInventoryDetail("Çöp Kovası", "trash_bin_count")}
              className="text-center p-4 bg-gray-50 rounded-lg cursor-pointer hover:bg-gray-100 transition-colors"
            >
              <Trash className="h-8 w-8 text-gray-600 mx-auto mb-2" />
              <p className="text-2xl font-bold text-gray-900">{stats.totalTrashBins}</p>
              <p className="text-xs text-gray-700">Çöp Kovası</p>
            </div>
            
            <div 
              onClick={() => showInventoryDetail("Kamelya", "gazebo_count")}
              className="text-center p-4 bg-blue-50 rounded-lg cursor-pointer hover:bg-blue-100 transition-colors"
            >
              <Home className="h-8 w-8 text-blue-600 mx-auto mb-2" />
              <p className="text-2xl font-bold text-blue-900">{stats.totalGazebos}</p>
              <p className="text-xs text-blue-700">Kamelya</p>
            </div>
            
          </div>
        </CardContent>
      </Card>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* Tesis İstatistikleri */}
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Dumbbell className="h-5 w-5 text-orange-600" />
              Tesis Durumu
            </CardTitle>
            <CardDescription>Parklardaki tesislerin dağılımı</CardDescription>
          </CardHeader>
          <CardContent className="space-y-3">
            <div 
              onClick={() => showRunningTrackDetail()}
              className="flex items-center justify-between p-2 rounded hover:bg-blue-50 cursor-pointer transition-colors"
            >
              <div className="flex items-center gap-2">
                <Footprints className="h-4 w-4 text-blue-600" />
                <span className="text-sm">Yürüme/Koşu Yolu</span>
              </div>
              <Badge variant="secondary">{stats.parksWithRunningTrack} park</Badge>
            </div>
            
            <div 
              onClick={() => showPlaygroundDetail()}
              className="flex items-center justify-between p-2 rounded hover:bg-purple-50 cursor-pointer transition-colors"
            >
              <div className="flex items-center gap-2">
                <Baby className="h-4 w-4 text-purple-600" />
                <span className="text-sm">Çocuk Oyun Grubu</span>
              </div>
              <Badge variant="secondary">{stats.parksWithPlayground} park</Badge>
            </div>
            
            <div 
              onClick={() => showSportsEquipmentDetail()}
              className="flex items-center justify-between p-2 rounded hover:bg-orange-50 cursor-pointer transition-colors"
            >
              <div className="flex items-center gap-2">
                <Dumbbell className="h-4 w-4 text-orange-600" />
                <span className="text-sm">Spor Aleti</span>
              </div>
              <Badge variant="secondary">{stats.parksWithSportsEquipment} park</Badge>
            </div>
            
            <div 
              onClick={() => showFacilityDetail("WC", "has_wc")}
              className="flex items-center justify-between p-2 rounded hover:bg-gray-50 cursor-pointer transition-colors"
            >
              <div className="flex items-center gap-2">
                <Home className="h-4 w-4 text-gray-600" />
                <span className="text-sm">WC</span>
              </div>
              <Badge variant="secondary">{stats.parksWithWC} park</Badge>
            </div>
            
            <div 
              onClick={() => showFountainDetail && showFountainDetail()}
              className="flex items-center justify-between p-2 rounded hover:bg-blue-50 cursor-pointer transition-colors"
            >
              <div className="flex items-center gap-2">
                <Droplet className="h-4 w-4 text-blue-400" />
                <span className="text-sm">Havuz</span>
              </div>
              <Badge variant="secondary">{stats.parksWithFountain} park</Badge>
            </div>
            
            <div 
              onClick={() => showFacilityDetail("Otopark", "has_parking")}
              className="flex items-center justify-between p-2 rounded hover:bg-indigo-50 cursor-pointer transition-colors"
            >
              <div className="flex items-center gap-2">
                <ParkingCircle className="h-4 w-4 text-indigo-600" />
                <span className="text-sm">Otopark</span>
              </div>
              <Badge variant="secondary">{stats.parksWithParking} park</Badge>
            </div>
          </CardContent>
        </Card>

        {/* Spor Sahaları İstatistikleri */}
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Dumbbell className="h-5 w-5 text-orange-600" />
              Spor Sahaları
            </CardTitle>
            <CardDescription>Parklardaki spor tesisleri</CardDescription>
          </CardHeader>
          <CardContent className="space-y-3">
            <div 
              onClick={() => showFacilityDetail("Basketbol Sahası", "has_basketball_court")}
              className="flex items-center justify-between p-2 rounded hover:bg-orange-50 cursor-pointer transition-colors"
            >
              <div className="flex items-center gap-2">
                <span className="text-lg">🏀</span>
                <span className="text-sm">Basketbol Sahası</span>
              </div>
              <Badge variant="secondary">{stats.parksWithBasketball} park</Badge>
            </div>
            
            <div 
              onClick={() => showFacilityDetail("Futbol Sahası", "has_football_field")}
              className="flex items-center justify-between p-2 rounded hover:bg-green-50 cursor-pointer transition-colors"
            >
              <div className="flex items-center gap-2">
                <span className="text-lg">⚽</span>
                <span className="text-sm">Futbol Sahası</span>
              </div>
              <Badge variant="secondary">{stats.parksWithFootball} park</Badge>
            </div>
            
            <div 
              onClick={() => showFacilityDetail("Voleybol Sahası", "has_volleyball_court")}
              className="flex items-center justify-between p-2 rounded hover:bg-blue-50 cursor-pointer transition-colors"
            >
              <div className="flex items-center gap-2">
                <span className="text-lg">🏐</span>
                <span className="text-sm">Voleybol Sahası</span>
              </div>
              <Badge variant="secondary">{stats.parksWithVolleyball} park</Badge>
            </div>
            
            <div 
              onClick={() => showFacilityDetail("Tenis Kortu", "has_tennis_court")}
              className="flex items-center justify-between p-2 rounded hover:bg-yellow-50 cursor-pointer transition-colors"
            >
              <div className="flex items-center gap-2">
                <span className="text-lg">🎾</span>
                <span className="text-sm">Tenis Kortu</span>
              </div>
              <Badge variant="secondary">{stats.parksWithTennis} park</Badge>
            </div>
          </CardContent>
        </Card>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-1 gap-6">
        {/* Sulama Sistemi İstatistikleri */}
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Droplets className="h-5 w-5 text-blue-500" />
              Sulama Sistemi Dağılımı
            </CardTitle>
            <CardDescription>Parklardaki sulama yöntemleri</CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div 
              onClick={() => showIrrigationDetail("Otomatik Sulama", "otomatik")}
              className="space-y-2 p-3 rounded-lg hover:bg-green-50 cursor-pointer transition-colors"
            >
              <div className="flex justify-between items-center">
                <span className="text-sm font-medium">Otomatik Sulama</span>
                <Badge className="bg-green-100 text-green-700">{stats.automaticIrrigation} park</Badge>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2">
                <div 
                  className="bg-green-500 h-2 rounded-full" 
                  style={{width: `${(stats.automaticIrrigation / stats.totalParks * 100).toFixed(0)}%`}}
                ></div>
              </div>
            </div>

            <div 
              onClick={() => showIrrigationDetail("Manuel Sulama", "manuel")}
              className="space-y-2 p-3 rounded-lg hover:bg-blue-50 cursor-pointer transition-colors"
            >
              <div className="flex justify-between items-center">
                <span className="text-sm font-medium">Manuel Sulama</span>
                <Badge className="bg-blue-100 text-blue-700">{stats.manualIrrigation} park</Badge>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2">
                <div 
                  className="bg-blue-500 h-2 rounded-full" 
                  style={{width: `${(stats.manualIrrigation / stats.totalParks * 100).toFixed(0)}%`}}
                ></div>
              </div>
            </div>

            <div 
              onClick={() => showIrrigationDetail("Hortumla Sulama", "hortumla")}
              className="space-y-2 p-3 rounded-lg hover:bg-yellow-50 cursor-pointer transition-colors"
            >
              <div className="flex justify-between items-center">
                <span className="text-sm font-medium">Hortumla Sulama</span>
                <Badge className="bg-yellow-100 text-yellow-700">{stats.hoseIrrigation} park</Badge>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2">
                <div 
                  className="bg-yellow-500 h-2 rounded-full" 
                  style={{width: `${(stats.hoseIrrigation / stats.totalParks * 100).toFixed(0)}%`}}
                ></div>
              </div>
            </div>

            <div 
              onClick={() => showIrrigationDetail("Sulama Yok", "yok")}
              className="space-y-2 p-3 rounded-lg hover:bg-gray-50 cursor-pointer transition-colors"
            >
              <div className="flex justify-between items-center">
                <span className="text-sm font-medium">Sulama Yok</span>
                <Badge className="bg-gray-100 text-gray-700">{stats.noIrrigation} park</Badge>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2">
                <div 
                  className="bg-gray-400 h-2 rounded-full" 
                  style={{width: `${(stats.noIrrigation / stats.totalParks * 100).toFixed(0)}%`}}
                ></div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Park Atama Durumu (Park Görevlisi) */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Users className="h-5 w-5 text-purple-600" />
            Park Atama Durumu (Park Görevlisi)
          </CardTitle>
          <CardDescription>Park görevlisi atanmış ve atanmamış parklar</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-2 gap-4">
            <div className="text-center p-6 bg-purple-50 rounded-lg">
              <p className="text-3xl font-bold text-purple-900">{stats.assignedParks}</p>
              <p className="text-sm text-purple-700 mt-1">Park Görevlisi Var</p>
              <div className="w-full bg-purple-200 rounded-full h-2 mt-3">
                <div 
                  className="bg-purple-600 h-2 rounded-full" 
                  style={{width: `${(stats.assignedParks / stats.totalParks * 100).toFixed(0)}%`}}
                ></div>
              </div>
            </div>
            
            <div 
              onClick={() => {
                if (stats.unassignedParks > 0 && onUnassignedParkClick) {
                  onUnassignedParkClick();
                }
              }}
              className={`text-center p-6 bg-orange-50 rounded-lg ${stats.unassignedParks > 0 ? 'cursor-pointer hover:bg-orange-100 hover:shadow-md transition-all' : ''}`}
            >
              <p className="text-3xl font-bold text-orange-900">{stats.unassignedParks}</p>
              <p className="text-sm text-orange-700 mt-1">Park Görevlisi Yok</p>
              {stats.unassignedParks > 0 && (
                <p className="text-xs text-orange-500 mt-2">👆 Tıkla ve ata</p>
              )}
              <div className="w-full bg-orange-200 rounded-full h-2 mt-3">
                <div 
                  className="bg-orange-600 h-2 rounded-full" 
                  style={{width: `${(stats.unassignedParks / stats.totalParks * 100).toFixed(0)}%`}}
                ></div>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </>
  );
};

export default InventorySummaryCards;
